export default {
      id: "lock-usage",
      viewBox: "0 0 12 12",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#lock",
      toString: function () {
        return this.url;
      }
    }